const BUSHEL_CROPS = new Set(["CANOLA", "CORN", "SOYBEANS", "SPRING_WHEAT"]);
const SILAGE_CROPS = new Set(["BARLEY_SILAGE", "OAT_SILAGE", "SILAGE_CORN", "TRITICALE_SILAGE", "WHEAT_SILAGE"]);

export function defaultHolosHarvestMethod(crop) {
  return SILAGE_CROPS.has(crop) ? "Silage" : "CashCrop";
}

export function isSummerFallow(crop) {
  return String(crop || "").replace(/[^a-z]/gi, "").toLowerCase() === "summerfallow";
}

export function requiresMetricYield(crop) {
  return Boolean(crop) && !BUSHEL_CROPS.has(crop);
}

export function cropYieldError(crop, value) {
  if (value === "" || value === null || value === undefined) return "";
  const number = Number(value);
  if (!Number.isFinite(number)) return "Enter a finite yield.";
  if (isSummerFallow(crop)) {
    return number === 0 ? "" : "Summer fallow has no harvest. Enter zero.";
  }
  return number > 0 ? "" : "Enter a yield greater than zero.";
}
